export const getFromLocalStorage = (key, defaultVal=null) => {
  const str = window.localStorage.getItem(key);
  if(!str) return defaultVal;
  return JSON.parse(str);
}

export const saveToLocalStorage = (key, value) => {
  window.localStorage.setItem (key, JSON.stringify(value));
}